import React from "react";
import { injectIntl } from "react-intl";
import {
  TableWrapper,
  Table,
  TRVertical,
  TD,
  EditButton,
  EditIcon,
  Tooltip,
  RowLabel,
} from "../styled";

const VerticalTable = (props) => {
  const {
    columns,
    rows,
    validationError,
    renderInput,
    deleteRow,
    builder,
    sumColumn,
    intl,
    disabled,
  } = props;

  return (
    <TableWrapper>
      <Table>
        <tbody>
          {rows.map((row, rowIndex) => {
            const { columns: rowColumns } = row;

            return (
              <TRVertical key={`tr-${rowIndex}`}>
                {rowColumns.map((rowColumn, rowColIndex) => {
                  const { columnId, value } = rowColumn;
                  const column =
                    columns.find((col) => col.id === columnId) || {};
                  const {
                    label,
                    type,
                    disabled: columnDisabled = false,
                  } = column;
                  const { critical = {} } = validationError;
                  const error = critical[`${rowIndex}:${rowColIndex}`];

                  return (
                    <TD key={`td-${rowIndex}-${rowColIndex}`} error={error}>
                      <RowLabel className={`vertical-table-row`}>
                        {label}
                      </RowLabel>
                      {renderInput(
                        type,
                        value,
                        rowIndex,
                        rowColIndex,
                        true,
                        columnDisabled || disabled
                      )}
                      {error && <Tooltip>{error}</Tooltip>}
                    </TD>
                  );
                })}
                <EditButton
                  onClick={() => deleteRow(rowIndex)}
                  disabled={!builder && (row.locked || disabled)}
                  style={{ marginLeft: "5px" }}
                >
                  <EditIcon className="far fa-times" />
                </EditButton>
              </TRVertical>
            );
          })}
        </tbody>
        {columns.some(({ sum }) => sum) && (
          <TRVertical>
            <RowLabel>{intl.formatMessage({ id: "InputTable.Sum" })}</RowLabel>
            {columns.map((column, index) => {
              if (!column.sum) return;

              return (
                <TD key={`sum-${index}`} sum>
                  <RowLabel>{`${column?.label}: `}</RowLabel>
                  <p style={{ marginLeft: "5px" }}>{sumColumn(index)}</p>
                </TD>
              );
            })}
          </TRVertical>
        )}
      </Table>
    </TableWrapper>
  );
};

export default injectIntl(VerticalTable);
